import { Injectable } from '@angular/core';

import { Http, Response, Headers, RequestOptions } from '@angular/http';
// import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { ConfigService } from '../config/config-service';
// import { SessionService } from './session.service';
import { environment } from '../../environments/environment';

@Injectable()
export class PreregistroService {
	private config: ConfigService;
	// private _token: any;
	private admin_api: String;
	// private dbname: string;

	constructor(
		private http: Http,
		// private ss: SessionService,
	) {
		this.config = new ConfigService();
        // this.host_api = this.ss.getData('host_api');
        this.admin_api = environment.admin_api;
		// this._token = sessionStorage.getItem('api-token');
		// this.dbname = this.ss.getData('dbname');
	}

	save(data) {
		let url = this.admin_api + '/clientes/preregistro';
		let params = data;
		let headers = new Headers({ 'Content-type': 'application/json' });
		// headers.append('Authorization', "Bearer "+ this._token);
		// headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/preregistro.service.ts